import React from 'react';

export const ProductCheckmarkRow = ({productType, landing}) => {
    return (
        <div className={`bundle-box-product${landing ? " bundle-box-landing" : ""}`}><span className="green-bullet"/>{productType}</div>
    )
}